import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MaterialModule } from '@fantaz/shared/ui/material/src/lib/shared-ui-material.module';
@Component({
  standalone: true,
  selector: 'fz-stat-box',
  templateUrl: './stat-box.component.html',
  styleUrls: ['./stat-box.component.scss'],
  imports: [CommonModule, MaterialModule],
})
export class StatBoxComponent {}
